import * as React from 'react';
import { useTranslation } from 'react-i18next';
import cn from 'classnames';
import { useTheme } from '../../../../../theme';
import Money from '../../../../../Money';
import { CheckinCard, CheckinCardItem } from '@shared/CheckinCard';
const Receipt = ({ className, prices, totalPrice }) => {
    const { t } = useTranslation('Exchange');
    const { Receipt: theme } = useTheme('Widgets').Exchange;
    return (React.createElement(CheckinCard, { className: cn(theme.root, className) },
        React.createElement(CheckinCardItem, { className: theme.prices, delimiter: "line", delimiterGap: true }, prices === null || prices === void 0 ? void 0 : prices.map(priceItem => (React.createElement("div", { className: theme.row },
            React.createElement("span", { className: theme.label }, priceItem.label),
            React.createElement(Money, { moneyClassName: theme.money, money: priceItem.price }))))),
        React.createElement("div", { className: cn(theme.row, theme.row_total) },
            React.createElement("span", { className: theme.label }, t('Receipt.Total')),
            React.createElement(Money, { moneyClassName: theme.money, money: totalPrice }))));
};
export default Receipt;
